import React from 'react';
import { AuthActions } from 'Redux/thunks/auth.thunks';
import CenteredLayout from '../layout/centered';

import Button from 'Common/Button/Button';

function Logout() {
  const dispatch = useDispatch();
  function handleLogout() {
    dispatch(AuthActions.logout());
  }
  return (
    <CenteredLayout>
      <div className="logout">
        <h2>Logout?</h2>
        <Button onClick={handleLogout}>Logout</Button>
      </div>
    </CenteredLayout>
  );
}

export default Logout;
